// Auto-ported from the age-of-mcp /gallery. Low-poly parts flattened to a
// self-contained model (no shared helpers, no animations).
import * as THREE from "three";
import { defineModel } from "../../lib";

export const stoneBlockStack = defineModel({
  id: "stone-block-stack",
  batchId: "future",
  name: "Stone-block stack",
  tags: ["scenery","stone","block","stack","low-poly","age-of-mcp","future"],
  summary: "Cut ashlar blocks — masonry for sturdy and prestige builds.",
  description: "Ported from the age-of-mcp gallery (future library).",
  author: "age-of-mcp",
  footprint: 0.42,
  parts: () => [
      { geometry: new THREE.BoxGeometry(0.28, 0.16, 0.24), color: "#8d8a82", position: [-0.1, 0.08, 0.02], rotation: [0, 0.08, 0] },
      { geometry: new THREE.BoxGeometry(0.26, 0.16, 0.22), color: "#7e7b73", position: [0.16, 0.08, -0.04], rotation: [0, -0.12, 0] },
      { geometry: new THREE.BoxGeometry(0.24, 0.15, 0.22), color: "#9b988f", position: [0, 0.235, 0], rotation: [0, 0.2, 0] },
      { geometry: new THREE.BoxGeometry(0.2, 0.15, 0.18), color: "#8d8a82", position: [-0.12, 0.385, 0.04], rotation: [0, -0.15, 0] },
      { geometry: new THREE.BoxGeometry(0.1, 0.07, 0.09), color: "#7e7b73", position: [0.2, 0.05, 0.1], rotation: [0.06, 0.5, 0.05] },
    ],
  animations: [],
});
